export type SameDayRestrictedTicketPrice = {
  ticket_type?: string | null;
  ticket_category?: string | null;
  flight_number?: string | null;
};

export const isAnaFlightNumber = (flightNumber?: string | null): boolean =>
  !!flightNumber && /^(ANA|NH)/.test(flightNumber);

export const isStandardTicketType = (ticketType: string | null | undefined): boolean =>
  ticketType === 'スタンダード';

export const isSameDayRestrictedTicket = (
  price: SameDayRestrictedTicketPrice,
  flightNumber?: string | null
): boolean => {
  if (price.ticket_category === 'unchangeable') return true;
  const effectiveFlightNumber = price.flight_number || flightNumber || null;
  return isAnaFlightNumber(effectiveFlightNumber) && isStandardTicketType(price.ticket_type);
};
